export default {
  conditionPageService (experienceId) {
    if (experienceId) {
      return 'Experience Detail'
    }
    return 'Cleaner Detail'
  },
  conditionWithParamId (reviewObj) {
    if (reviewObj.experience_id) {
      return reviewObj.experience_id
    }
    return reviewObj.professional_id
  },
  cutText (value) {
    if (!value) return ''
    if (value.length > 80) {
      this.hasMoreLine = true
      return value.toString().slice(0, 80) + '...'
    } else {
      return value
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/reviewHelpers.js